import axios from 'axios'

import {
  GET_ALL_CONTACT_TYPES,
  REMOVE_FILTERS_VALUES,
  GET_ALL_CONTACT_FILTERS,
  ADD_CONTACT_FILTER_TYPE,
  CHANGE_SWITCH,
  CHANGE_FILTERS_VALUES,
  SET_OPTIONS,
  SET_FILTERS_VALUES_ON_LOAD,
  CHANGE_SWITCH_DB,
  REMOVE_FILTER,
  SET_USERS_OPTIONS,
  CLEAR_FILTERS,
} from './types'

export const getContactFilterTypes = (userId, categoryId) => async (dispatch) => {
  try {
    const response = await axios.get(`/contact-filters/type/${userId}`, {
      params: { categoryId },
    })
    dispatch({
      type: GET_ALL_CONTACT_TYPES,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const loadContactFilters = (typeId) => async (dispatch) => {
  try {
    if (typeId) {
      const response = await axios.get(`/contact-filters/${typeId}`)
      dispatch({
        type: GET_ALL_CONTACT_FILTERS,
        payload: { data: response.data, typeId },
      })
      if (response.status === 200) {
        return response.data
      }
    } else {
      dispatch({
        type: GET_ALL_CONTACT_FILTERS,
        payload: { data: {}, typeId },
      })
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const createContactFilterType = (model) => async (dispatch) => {
  try {
    const response = await axios.post(`/contact-filters/type`, model)
    dispatch({
      type: ADD_CONTACT_FILTER_TYPE,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const switchChanges = (name, value, id, filtersFor, isExtension) => async (dispatch) => {
  try {
    dispatch({
      type: CHANGE_SWITCH,
      payload: { name, value },
    })
    if (filtersFor === 'contact') {
      dispatch({
        type: CHANGE_SWITCH_DB,
        payload: { name, value, id, extension: isExtension },
      })
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const addContactFilters = (model) => async () => {
  try {
    await axios.post('/contact-filters/', model)
  } catch (error) {
    throw new Error(error)
  }
}

export const clearFilters = () => (dispatch) => {
  dispatch({
    type: CLEAR_FILTERS,
  })
}

export const removeFilter = (filterName) => (dispatch) => {
  dispatch({
    type: REMOVE_FILTER,
    payload: filterName,
  })
}

export const setFiltersValue = (name, value) => async (dispatch) => {
  try {
    dispatch({
      type: CHANGE_FILTERS_VALUES,
      payload: { name, value },
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const removeFiltersValues = () => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_FILTERS_VALUES,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const setFiltersOnLoad = (data) => async (dispatch) => {
  dispatch({
    type: SET_FILTERS_VALUES_ON_LOAD,
    payload: data,
  })
}

export const getUsersForDivision = (divisionId) => async (dispatch) => {
  try {
    const response = await axios.get(`/support-types/optionsForFilters/usersForDivision`, {
      params: { divisionId },
    })

    dispatch({
      type: SET_USERS_OPTIONS,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getOptions = (contactCategory) => async (dispatch) => {
  try {
    const response = await axios.get(`/support-types/optionsForFilters`, {
      params: { contactCategory },
    })
    let options = {}
    response.data.map((i) => {
      return (options[i.name.replace(/\s/g, '')] = i.data)
    })

    dispatch({
      type: SET_OPTIONS,
      payload: options,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const deleteFilterType = (typeId) => async (dispatch) => {
  await axios.delete(`/contact-filters/${typeId}`)
  dispatch({
    type: GET_ALL_CONTACT_FILTERS,
    payload: { data: {}, typeId: null },
  })
}
